import React from 'react';

import { Stack, Grid } from '@metarouter-private/mr-mui';

import EventDebuggerClusterSelect from './EventDebuggerClusterSelect';
import EventSearch from './EventSearch';
import EventDebuggerTableRefreshButton from './EventDebuggerTableRefreshButton';
import EventDebuggerEventsRequestedSelect from './EventDebuggerEventsRequestedSelect';
import EventDebuggerIntegrationsSelect from './EventDebuggerIntegrationsSelect';
import EventDebuggerPipelineSelect from './EventDebuggerPipelineSelect';
import EventDebuggerStatusSelect from './EventDebuggerStatusSelect';
import EventDebuggerClearFiltersButton from './EventDebuggerClearFiltersButton';
import EventDebuggerSamplingTooltip from './EventDebuggerSamplingTooltip';
import EventDebuggerAdvancedSearch from './EventDebuggerAdvancedSearch';

const EventDebuggerTableHeader = () => {
  return (
    <Stack direction="column">
      <Grid container alignItems="center" flexWrap="nowrap" spacing={2}>
        <Grid item xs={2}>
          <EventDebuggerClusterSelect />
        </Grid>

        <Grid item flexGrow={1}>
          <EventSearch />
        </Grid>

        <Grid item xs={1}>
          <EventDebuggerEventsRequestedSelect />
        </Grid>

        <Grid item>
          <EventDebuggerTableRefreshButton />
        </Grid>

        <Grid item>
          <EventDebuggerSamplingTooltip />
        </Grid>
      </Grid>

      <Stack pt={2} direction="row" spacing={1} alignItems="center">
        <Grid item container spacing={1}>
          {/*
           * Why `width: 0`?
           *   There's a weird issue where the way our multiselects hide overflow allows the actual page
           *   to expand even if no parent elements do in the event hidden content reaches the edge of the page
           *
           *   The use of `width: 0` here ensures that the contents of the grid items can't exceed the flexed
           *   or gridded width of the items themselves
           */}
          <Grid item xs={5} width={0}>
            <EventDebuggerIntegrationsSelect />
          </Grid>

          <Grid item xs={5} width={0}>
            <EventDebuggerPipelineSelect />
          </Grid>

          <Grid item xs={2}>
            <EventDebuggerStatusSelect />
          </Grid>
        </Grid>

        <EventDebuggerClearFiltersButton />
      </Stack>

      <EventDebuggerAdvancedSearch />
    </Stack>
  );
};

export default EventDebuggerTableHeader;
